<template>
    <svg
      :fill="svgColor"
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      :width="width"
    >
      <path
        d="M21 4h-5V2c0-.553-.448-1-1-1h-6c-.552 0-1 .447-1 1v2H3c-1.657 0-3 1.343-3 3v12c0 1.657 1.343 3 3 3h18c1.657 0 3-1.343 3-3V7c0-1.657-1.343-3-3-3ZM9 2h6v2H9V2Zm12 17c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1h18c.552 0 1 .448 1 1v12ZM15 9h-6c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1Zm0 4h-6c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    props: {
      svgColor: {
        type: String,
        default: "#000000", // Default fill color
      },
      width: {
        type: String,
        default: "24px", // Default width
      },
      height: {
        type: String,
        default: "24px", // Default height
      },
    },
  };
  </script>
